// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__Dq8Fa","outlined":"Tag_outlined__u1wXj"};